import React from "react";
//#region types
import { RouteInfo } from "models/utilTypes/routeTypes";
import { RouteConfig } from "./routeConfig";
//#endregion
//#region components
import { Route, Routes } from "react-router-dom";
//#endregion

const RouterSwitch: React.FC = () => {
  const getRoutes = (routes?: RouteInfo[]) =>
    routes && routes.length > 0 ? routes.map((child, index) => getRoute(child, index)) : <></>;

  const getRoute = (route: RouteInfo, index: number) => (
    <Route key={`route-${index}`} path={route.path} element={route.element} children={getRoutes(route.children)} />
  );

  const switchComponent = React.useMemo(() => <Routes>{getRoutes(RouteConfig)}</Routes>, []);

  return switchComponent;
};

export default RouterSwitch;
